import { render, staticRenderFns } from "./GooglePlayFormItem.vue?vue&type=template&id=09b1abc8&scoped=true&"
import script from "./GooglePlayFormItem.vue?vue&type=script&lang=js&"
export * from "./GooglePlayFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1abc8",
  null
  
)

export default component.exports